import * as trace from 'owa-trace';
import {
    Calendar,
    addToCalendarsCache,
    getCalendarEntry,
    removeCalendarFromCalendarsCache,
} from 'owa-calendar-cache';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { replaceCalendar } from 'owa-calendar-surface-calendars-store';
import type { RenameCalendarResultType } from '../services/renameCalendarService';

export function processRenameServiceResponse(
    response: RenameCalendarResultType,
    calendar: Calendar,
    calendars: Calendar[],
    newCalendarName: string
): void {
    const oldCalendarEntry = getCalendarEntry(calendar);
    const newFolderId = response.FolderId ?? oldCalendarEntry.FolderId;
    const newCalendarId = response.calendarId;

    removeCalendarFromCalendarsCache(calendar);
    addToCalendarsCache({
        ...oldCalendarEntry,
        calendarId: {
            id: newCalendarId.id,
            changeKey: newCalendarId.changeKey,
            mailboxInfo: calendar.id.mailboxInfo,
        },
        FolderId: newFolderId,
        CalendarName: calendar.displayName,
    });

    const foundCalendarResult = findInArray(calendars, item => {
        return item.id.id === calendar.id.id;
    });

    if (foundCalendarResult) {
        const colorScheme = foundCalendarResult.item.colorScheme;
        const newCalendar: Calendar = {
            id: {
                id: newCalendarId.id,
                changeKey: newCalendarId.changeKey,
                mailboxInfo: calendar.id.mailboxInfo,
            },
            displayName: newCalendarName,
            colorScheme: colorScheme,
        };
        replaceCalendar(newCalendar, foundCalendarResult.index);
    } else {
        trace.errorThatWillCauseAlert(`[renameCalendar] Cannot find calendar id: ${calendar.id}`);
    }
}
